<template>
    <div class="p-15 bg-white">
        <EsealInfo :sealDetail="sealDetail" v-if="showDetail"></EsealInfo>
    </div>
</template>

<script>
    import EsealInfo from '../../components/EsealInfo'
    import store from '@/modules'
    import {mapState} from 'vuex'

    export default {
        components: {
            EsealInfo
        },
        data() {
            return {
                eSeal: {},
                showDetail: false
            }
        },
        computed: {
            ...mapState({}),
            sealDetail: () => {
                return store.state.order.sealDetail
            }
        },
        created() {
            if (this.$route.query.id) this.$store.dispatch('order/getSealDetail', {id: this.$route.query.id}).then(() => this.showDetail = true)
        }
    }
</script>

<style>

</style>
